require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.3@core-js/library/modules/es7.symbol.observable.js
// module id = 363
// module chunks = 0